export enum CommentCategory {
    projectListing = 'projectListing',
    project = 'project',
    projectUpdate = 'projectUpdate',
    userProjectListing = 'userProjectListing'
  }